var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{attrs:{"fs":_vm.couponFields,"api":"features","editLink":"/admin/features","addLink":"/admin/features/new"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }